import React, { useContext } from 'react';

import { HowitWorksCurve, HowitWorksWrapper, HowItWorksList, CircularWrapper } from './HowItWorkStyles';
import { OrangeBorder } from '../../Styles';
import { Container, Heading, FlexDiv, GenericP, GenericDiv } from 'commonStyles';
import { isMobileContext } from 'UtilityComponents/Util';
import DisplayContext from 'UtilityComponents/displayContext';
import { HowItWorksData } from '../../config';

const HowItWorks = ({ colorTheme }) => {
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);
	const { list, heading, descp } = HowItWorksData;
	return (
		<GenericDiv position='relative' overflow='hidden'>
			<HowitWorksCurve />
			<HowitWorksWrapper colorTheme={colorTheme} id='Works'>
				<Container>
					<OrangeBorder />
					<Heading
						color={colorTheme === 'light' ? '#000' : '#fff'}
						fontSize={`${isMobile ? '24px' : ''}`}
						marBt={`${isMobile ? '16px' : '8px'}`}>
						{heading}
					</Heading>
					<GenericP
						fsize='16px'
						color={colorTheme === 'light' ? 'inherit' : '#C9C9C9'}
						bottom_M={isMobile ? 30 : 90}>
						{descp}
					</GenericP>
					<HowItWorksList>
						{list.map((item) =>(
							<li key={item.id}>
								<FlexDiv position='relative' align='center' justify='center' bottom_M={56}>
									<FlexDiv justify='space-between' align='center' width={`${isMobile ? '96px' : '168px'}`}>
										<img src={item.img} alt={item.alt} />
									</FlexDiv>
									<CircularWrapper>{item.id}.</CircularWrapper>
								</FlexDiv>
								<GenericP
									fsize={isMobile ? '16px' : '24px'}
									text_align='center'
									f_weight={700}
									color={colorTheme === 'light' ? 'inherit' : '#fff'}
									bottom_M={5}>
									{item.title}
								</GenericP>
								<GenericP color={colorTheme === 'light' ? 'inherit' : '#cacaca'} text_align='center'>
									{item.descp}
								</GenericP>
							</li>
						))}
					</HowItWorksList>
				</Container>
			</HowitWorksWrapper>
		</GenericDiv>
	);
};

export default HowItWorks;
